import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { rootAppViewEpics } from '../app/store/Epics';
import { Middleware, configureStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import createRootReducer from './reducer';
import { rootRoutingEpics } from '../app/store/routingSlice/Epics';
import { rootDashboardViewEpics } from '../routes/Dashboard/store/Epics';
import { rootApiEpics } from 'src/api/store/Epics';
import { rootReceiptsViewEpics } from 'src/routes/Receipts/store/Epics';
import { rootSettingsViewEpics } from 'src/routes/Settings/store/Epics';
import { rootInboxViewEpics } from 'src/routes/Inbox/store/Epics';
import { rootReportsViewEpics } from 'src/routes/Reports/store/Epics';

const epicsArray = [
  ...rootRoutingEpics,
  ...rootAppViewEpics,
  ...rootDashboardViewEpics,
  ...rootApiEpics,
  ...rootReceiptsViewEpics,
  ...rootSettingsViewEpics,
  ...rootInboxViewEpics,
  ...rootReportsViewEpics,
];

export const rootEpic = combineEpics(...(epicsArray as any));

const epicMiddleware = createEpicMiddleware();
const browserHistory = createBrowserHistory();
const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({ history: browserHistory });

export const configureAppStore = (preloadedState = {}) => {
  // WORKAROUND: typing
  const middleware: Middleware[] = [epicMiddleware, routerMiddleware] as any;

  const isDevEnvironment = Boolean(
    !process.env.NODE_ENV || process.env.NODE_ENV === 'development',
  );

  const store = configureStore({
    reducer: createRootReducer(routerReducer),
    preloadedState,
    middleware,
    devTools: isDevEnvironment,
  });
  epicMiddleware.run(rootEpic);
  return store;
};

export const store = configureAppStore();
export const history = createReduxHistory(store);
export type RootState = ReturnType<typeof store.getState>;
